import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold font-cormorant mb-4">404</h1>
        <p className="text-muted mb-6">Page not found</p>
        <Link to="/" className="text-primary hover:underline">
          Return home
        </Link>
      </div>
    </div>
  );
}
